import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Task } from 'src/app/rent-module/shared/entities/task/task';
import { TaskView } from '../task-detail-view/task-detail-view.component';

@Component({
  selector: 'app-nexcore-default-task-view',
  templateUrl: './nexcore-default-task-view.component.html',
  styleUrls: ['./nexcore-default-task-view.component.scss']
})
export class NexcoreDefaultTaskViewComponent implements TaskView  {

  @Input() task: Task;
  @Output() complete = new EventEmitter<{ task: Task, formModelInput?: any }>();

  constructor(
  ) {

  }
  
  getHeadline(): string {
    return this.task?.title;
  }

  completeTask($event: any) {
    this.complete.emit({
      task: this.task,
      formModelInput: undefined
    });
  }
  
  
}
